import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgNewTab = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", role: "img", ref, ...props, children: [
  /* @__PURE__ */ jsx("title", { children: "action-new-tab" }),
  /* @__PURE__ */ jsx("g", { id: "b9e41a99-883f-4cd0-8bab-21e4ccd54b89", "data-name": "Layer 2", children: /* @__PURE__ */ jsxs("g", { id: "a36de643-a99a-44a8-a7eb-18703c14b80a", "data-name": "Layer 1", children: [
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: 18.86, y1: 17.01, x2: 13.14, y2: 17.01, style: {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2
        } }),
        /* @__PURE__ */ jsx("line", { x1: 16, y1: 14.15, x2: 16, y2: 19.88, style: {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2
        } })
      ] }),
      /* @__PURE__ */ jsx("polyline", { points: "3 20.88 6.81 20.88 9.86 11.12 15.47 11.12 17.33 11.12 22.14 11.12 25.19 20.88 29 20.88", style: {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      } })
    ] }),
    /* @__PURE__ */ jsx("rect", { width: 32, height: 32, style: {
      fill: "none"
    } })
  ] }) })
] });
const ForwardRef = forwardRef(SvgNewTab);
export default ForwardRef;
